import { Stack, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React, { useState } from 'react';
import ModalTemplate from 'v2/components/Modal/ModalTemplate';
import useModalContext from 'v2/components/Modal/useModalContext';
import useSnackbarContext from 'v2/components/Snackbar/useSnackbarContext';
import { formatTranslation } from 'v2/utils/formatTranslation';

interface Props {
  visitorName: string;
  onConfirm: () => Promise<void>;
}

const CancelVisitModal: React.FC<Props> = ({ visitorName, onConfirm }) => {
  const { translation } = useTranslation();
  const { closeModal } = useModalContext();
  const { showSnackbar } = useSnackbarContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClick = async () => {
    setIsSubmitting(true);
    try {
      await onConfirm();
      showSnackbar(translation.visit_cancelled, { severity: 'success' });
      closeModal();
    } catch {
      setIsSubmitting(false);
      showSnackbar(translation.visit_error_cancelling, { severity: 'error' });
    }
  };

  return (
    <ModalTemplate
      title={translation.cancel_visit}
      primaryAction={{
        label: translation.cancel_visit,
        onClick: handleClick,
        dangerzone: true,
        loading: isSubmitting
      }}
      secondaryAction={{ label: translation.close }}
    >
      <Stack spacing={3}>
        <Typography variant="body2">
          {formatTranslation(translation.cancel_visit_confirmation, { name: visitorName })}
        </Typography>
      </Stack>
    </ModalTemplate>
  );
};

export default CancelVisitModal;
